import React, { forwardRef, useImperativeHandle } from 'react';
// import Application from '../pdf/Application.pdf';
// import Application from '../pdf/ApplicationForm.pdf'
import Application from '../pdf/Application.pdf'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
// import icon from '../All/images/tick-icon.png';

import { removeBracketedText } from '../Axiosinstance';

const ApplicationForm = forwardRef(( dataProp , ref) => {

    const handleDownload = async (studentdetails) => {
        try {
            const pdfBytes = await fetch(Application).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);

            let image;
            const imageUrl = studentdetails?.profileUrl || '';
            // const imageUrl = 'https://res.cloudinary.com/dyjwwi8ea/raw/upload/v1722238090/LMS/courses/pexels-mikebirdy-188777.jpg';
            // const imageResponse = await fetch(imageUrl);
            // const imageBytes = await imageResponse.arrayBuffer();


            if (imageUrl) {
                // Fetch and embed the image
                const imageResponse = await fetch(imageUrl);
                const imageBytes = await imageResponse.arrayBuffer();

                if (imageUrl.endsWith('.png')) {
                    image = await pdfDoc.embedPng(imageBytes);
                } else if (imageUrl.endsWith('.jpg') || imageUrl.endsWith('.jpeg')) {
                    image = await pdfDoc.embedJpg(imageBytes);
                } else {
                    throw new Error("Unsupported image format. Only PNG and JPG are supported.");
                }
            }
            // Get the fifth page
            const pagess = pdfDoc.getPages();
            const fifthPages = pagess[0]; // Index is 0-based
            // Draw the image on the fifth page
            if (image) {
                const { width, height } = fifthPages.getSize();
                fifthPages.drawImage(image, {
                    x: 453, // Adjust as needed
                    y: 670, // Adjust as needed
                    width: 87, // Adjust as needed
                    height: 85, // Adjust as needed
                });
            }


            // Access the pages
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const secondPage = pages[1];

            // Set font and size
            const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);
            const fontSize = 10;



            // Data to insert
            const studentName = (studentdetails?.name || '').toUpperCase();
            const passportNo = studentdetails?.passport || '';
            const passportexpire = studentdetails?.passportExpiryDate || '';
            const nric = studentdetails?.nric || '';
            const handphone = studentdetails?.phone || '';
            const officephone = studentdetails?.officephone || '';
            const email = studentdetails?.email || '';
            const dob = studentdetails?.dob || '';
            const citizenship = (studentdetails?.citizenship || '').toUpperCase();
            // const course = studentdetails?.course || '';
            const religion = (studentdetails?.religion || '').toUpperCase();
            const gender = (studentdetails?.gender || '').toUpperCase();
            const singapore = (studentdetails?.currentAddress || '').toUpperCase();
            const address = (studentdetails?.address || '').toUpperCase();
            const father = (studentdetails?.fatherName || '').toUpperCase();
            const fatherphone = (studentdetails?.fatherPhoneNo || '').toUpperCase();
            const fatherInfo = (father && fatherphone) ? `${father} / ${fatherphone}` : '';
            const brother = (studentdetails?.brotherName || '').toUpperCase();
            const brotherphone = (studentdetails?.brotherPhoneNo || '').toUpperCase();
            const brotherInfo = (brother && brotherphone) ? `${brother} / ${brotherphone}` : '';
            // const institute = (studentdetails?.fatherName || '').toUpperCase();
            const workExpirences = studentdetails?.workExpirences || '';

            const formatDate = (dateString) => {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            function formatDatepassport(dateString) {
                // Split the input date string
                const [year, month, day] = dateString.split('-');
                
                // Format to DD/MM/YYYY
                return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
            }

            // const course = (dataProp?.batch?.course || '').toUpperCase().replace(/\s*\(1\)$/, '');
            const course = removeBracketedText((studentdetails?.course || '')).toUpperCase();
            // const intakeId = (dataProp?.intakeId || '').toUpperCase().replace(/\s*\(1\)$/, '');
            const institutionDetails = studentdetails?.institutionDetails || [];

            // Draw existing text on different pages
            firstPage.drawText(studentName, { x: 180, y: 554, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(passportNo, { x: 160, y: 522, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(formatDatepassport(passportexpire), { x: 400, y: 523, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(nric, { x: 180, y: 490, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(formatDate(dob), { x: 400, y: 492, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(religion, { x: 135, y: 425, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(handphone, { x: 172, y: 393, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(officephone, { x: 420, y: 393, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(email, { x: 172, y: 361, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(citizenship, { x: 420, y: 425, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(course, { x: 200, y: 630, size: 11, font, color: rgb(0, 0, 0), });
            // firstPage.drawText(course, { x: 257, y: 249, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(fatherInfo, { x: 253, y: 168, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(brotherInfo, { x: 253, y: 135, size: 10, font, color: rgb(0, 0, 0), });



            //FOR LAST page
            const drawWrappedText = (page, text, xFirst, y, maxWidthFirst, xSubsequent, maxWidthSubsequent, font, fontSize, color) => {
                const lines = [];
                let currentLine = '';
                let words = text.split(' ');

                while (words.length > 0) {
                    let word = words.shift();
                    let testLine = currentLine + word + ' ';
                    let testWidth = font.widthOfTextAtSize(testLine, fontSize);

                    if (testWidth <= (lines.length === 0 ? maxWidthFirst : maxWidthSubsequent)) {
                        currentLine = testLine;
                    } else {
                        lines.push(currentLine.trim());
                        currentLine = word + ' ';
                    }
                }
                lines.push(currentLine.trim());

                // Draw lines
                lines.forEach((line, index) => {
                    page.drawText(line, {
                        x: index === 0 ? xFirst : xSubsequent,
                        y: y - (index * fontSize * 3),
                        size: fontSize,
                        font: font,
                        color: color
                    });
                });
            };

            drawWrappedText(firstPage, singapore, 190, 328, 330, 77, 410, font, 10, rgb(0, 0, 0));

            drawWrappedText(firstPage, address, 257, 249, 300, 77, 410, font, 10, rgb(0, 0, 0));


            //second page
            secondPage.drawText(studentName, { x: 195, y: 318, size: 10, font, color: rgb(0, 0, 0), });


            // Function to handle text wrapping
            const wrapText = (text, maxWidth) => {
                const words = text.split(" ");
                let lines = [];
                let currentLine = words[0];

                for (let i = 1; i < words.length; i++) {
                    const word = words[i];
                    const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

                    if (width < maxWidth) {
                        currentLine += ` ${word}`;
                    } else {
                        lines.push(currentLine);
                        currentLine = word;
                    }
                }
                lines.push(currentLine);
                return lines;
            };

            //for institue
            const institutionInitialY = secondPage.getHeight() - 107; // Adjust Y position for initial placement
            const institutionRowSpacing = 28; // Space between rows
            const maxQualificationsXPosition = 550;

            const institutionXPositions = {
                institution: 52,          // Institution Name starts on the left
                year: 330,                // Year of Graduation in the middle
                qualificationsAchieved: 410,  // Qualifications on the right
            };

            institutionDetails.forEach((detail, index) => {
                const { institution, year, qualificationsAchieved } = detail;
                const institutionText = String(institution || '').toUpperCase();
                const qualificationsText = String(qualificationsAchieved || '').toUpperCase();
                const yearText = String(year || '').toUpperCase();  // Ensure year is a string

                // Wrap institution name if it exceeds the max x-position
                const institutionLines = wrapText(institutionText, institutionXPositions.year - institutionXPositions.institution);

                institutionLines.forEach((line, lineIndex) => {
                    secondPage.drawText(line, {
                        x: institutionXPositions.institution,
                        y: institutionInitialY - index * institutionRowSpacing - lineIndex * fontSize,
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                });

                // Adjusting for wrapped lines
                const institutionYOffset = institutionLines.length > 1 ? (institutionLines.length - 1) * fontSize : 0;

                // Draw the year in the middle
                secondPage.drawText(`${yearText}`, {
                    x: institutionXPositions.year,
                    y: institutionInitialY - index * institutionRowSpacing - institutionYOffset,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                });

                // Wrap qualifications if it exceeds the max x-position
                const qualificationsLines = wrapText(qualificationsText, maxQualificationsXPosition - institutionXPositions.qualificationsAchieved);

                qualificationsLines.forEach((line, lineIndex) => {
                    secondPage.drawText(line, {
                        x: institutionXPositions.qualificationsAchieved,
                        y: institutionInitialY - index * institutionRowSpacing - lineIndex * fontSize - institutionYOffset,
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                });
            });

            //for work
            const workExperienceInitialY = secondPage.getHeight() - 315; // Adjust Y position for initial placement
            const workExperienceRowSpacing = 28; // Space between rows
            const maxPositionXPosition = 550; // Max X position for positions before wrapping

            const workExperienceXPositions = {
                name: 52,
                year: 330,
                position: 410,
            };

            // Function to handle text wrapping remains the same (from your existing code)

            workExpirences.forEach((experience, index) => {
                const { name, year, position } = experience;

                const nameText = String(name || '').toUpperCase();
                const yearText = String(year || '').toUpperCase();  // Ensure year is a string
                const positionText = String(position || '').toUpperCase();

                // Wrap name if it exceeds the max x-position
                const nameLines = wrapText(nameText, workExperienceXPositions.position - workExperienceXPositions.name);

                nameLines.forEach((line, lineIndex) => {
                    secondPage.drawText(line, {
                        x: workExperienceXPositions.name,
                        y: workExperienceInitialY - index * workExperienceRowSpacing - lineIndex * fontSize,
                        size: fontSize,
                        font,
                        color: rgb(0, 0, 0),
                    });
                });

                // Draw the remaining details, adjusting for wrapped lines
                const nameYOffset = nameLines.length > 1 ? (nameLines.length - 1) * fontSize : 0;



                secondPage.drawText(`${yearText}`, {
                    x: workExperienceXPositions.year,
                    y: workExperienceInitialY - index * workExperienceRowSpacing - nameYOffset,
                    size: fontSize,
                    font,
                    color: rgb(0, 0, 0),
                });

                // secondPage.drawText(`${positionText}`, {
                //     x: workExperienceXPositions.position,
                //     y: workExperienceInitialY - index * workExperienceRowSpacing - nameYOffset,
                //     size: fontSize,
                //     font,
                //     color: rgb(0, 0, 0),
                // });

                 // Wrap workexperienceLines if it exceeds the max x-position
                 const workexperienceLines = wrapText(positionText, maxPositionXPosition - workExperienceXPositions.position);

                 workexperienceLines.forEach((line, lineIndex) => {
                     secondPage.drawText(line, {
                         x: workExperienceXPositions.position,
                         y: workExperienceInitialY - index * workExperienceRowSpacing - lineIndex * fontSize - nameYOffset,
                         size: fontSize,
                         font,
                         color: rgb(0, 0, 0),
                     });
                 });
            });


            // Load and embed the tick icon image
            const tickIconBytes = await fetch(icon).then(res => res.arrayBuffer());
            const tickIconImage = await pdfDoc.embedPng(tickIconBytes);

            // Define scaling factors
            const scaleFirstPage = 0.02; // Scale for the existing tick icons on the first page
            const scaleSixthPage = 0.012; // Scale for the sixth page
            const scaleSeventhPage = 0.014; // Scale for the seventh page
            const separateScaleFirstPage = 0.02; // Scale for the top-right corner tick icon

            // Set scaling factors

            const separateScaledIconFirstPage = tickIconImage.scale(separateScaleFirstPage);

            const { width: separateWidthFirstPage, height: separateHeightFirstPage } = separateScaledIconFirstPage;

            // Draw the separate tick icon in the top-right corner of the first page
            let xKnow, yKnow;
            switch (gender) {
                case 'MALE':
                    xKnow = 160; // Set the x position for referral
                    yKnow = 455; // Set the y position for referral
                    break;
                case 'FEMALE':
                    xKnow = 232; // Set the x position for Jurong Academy Website
                    yKnow = 457; // Set the y position for Jurong Academy Website
                    break;
                default:
                    xKnow = 160; // Set default x position
                    yKnow = 455; // Set default y position
            }

            firstPage.drawImage(tickIconImage, {
                x: xKnow,
                y: yKnow,
                width: separateWidthFirstPage,
                height: separateHeightFirstPage,
            });



            // Save the modified PDF
            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };


    const extractDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const toUpperCaseString11 = (dateString) => {
        const date = new Date(dateString);
        const month = getMonthName(date.getMonth());
        const year = date.getFullYear();
        return `${month} ${year}`;
    };

    const getMonthName = (monthNumber) => {
        const monthNames = [
            "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
            "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
        ];
        return monthNames[monthNumber];
    };


    function removeFirstTwoNumbersAfterDash(input) {
        // Split the input string into two parts at the first '-'
        const [prefix, suffix] = input.split('-');

        // Remove the first two numbers from the suffix
        const modifiedSuffix = suffix.replace(/^\d{2}/, '');

        // Recombine the prefix and modified suffix
        return `${prefix}-${modifiedSuffix}`;
    }

    // Example usage
    const result = removeFirstTwoNumbersAfterDash('DCE-241');
    console.log(result);  // Output: 'DCE-1'



    useImperativeHandle(ref, () => ({ handleDownload }));

    return null;
});

export default ApplicationForm;
